import { createSlice, PayloadAction } from "@reduxjs/toolkit"

export type Brand = {
  id: number
  name: string
}

export interface BrandState {
  brands: Brand[]
  selectedBrandId: number
  loading: boolean
}

const initialState: BrandState = {
  brands: [],
  selectedBrandId: 0,
  loading: false,
}

const brandSlice = createSlice({
  name: "brand",
  initialState,
  reducers: {
    setBrands(state, action: PayloadAction<Brand[]>) {
      // Always prepend the "All" option
      const brands = action.payload
      const allOption = { id: 0, name: "All" }
      state.brands = [allOption, ...brands]
    },
    setSelectedBrandId(state, action: PayloadAction<number>) {
      state.selectedBrandId = action.payload
    },
    setLoading(state, action: PayloadAction<boolean>) {
      state.loading = action.payload
    },
  },
})

export const { setBrands, setSelectedBrandId, setLoading } = brandSlice.actions
export default brandSlice.reducer
